import { IonButton } from '@ionic/react';
import RCForm, { useForm } from 'rc-field-form';
import React, { useState } from 'react';
import styled from 'styled-components';
import { t } from 'ttag';

import { ReactComponent as DarkLandscapeImageLeadCapture } from '@assets/login-lead-capture-landscape-dark.svg';
import { ReactComponent as LightLandscapeImageLeadCapture } from '@assets/login-lead-capture-landscape.svg';
import Field from '@components/Form/Field';
import InputField from '@components/Form/InputField';
import { UserSession, VerifyType } from '@custom-types/UserSession';
import useDeviceTheme, { Theme } from '@hooks/useDeviceTheme';

import { ErrorCode, authenticate, errorMessages } from './service';

const Form = styled(RCForm)`
  width: 100%;
`;

const Button = styled(IonButton)`
  margin: 32px 0;
  padding: 0 16px;
`;
const Heading = styled.div`
  margin: 32px 0;
  text-align: center;
`;
const ImageContainer = styled.div`
  display: flex;
  justify-content: center;
`;

interface Props {
  onSuccess: (user: UserSession) => void;
}

const EmailForm = ({ onSuccess }: Props) => {
  const deviceTheme = useDeviceTheme();
  const [isLoading, setIsLoading] = useState(false);
  const [form] = useForm();

  const onFinish = async () => {
    const { email } = await form.validateFields();
    try {
      setIsLoading(true);
      const user = await authenticate({ email, stage: VerifyType.Email });
      setIsLoading(false);
      onSuccess(user);
    } catch (errors) {
      setIsLoading(false);
      form.setFields([
        { name: 'email', errors: [errorMessages((errors as { type: ErrorCode }).type)] },
      ]);
    }
  };

  return (
    <Form
      form={form}
      initialValues={{ email: '' }}
      name="email-form"
      data-testid="email-form"
      // skipcq: JS-0417, JS-0336
      onFinish={onFinish}
    >
      <ImageContainer>
        {deviceTheme === Theme.Dark && <DarkLandscapeImageLeadCapture />}
        {deviceTheme === Theme.Light && <LightLandscapeImageLeadCapture />}
      </ImageContainer>
      <Heading>
        <h1>{t`Welcome To Lead Capture`}</h1>
      </Heading>
      <Field
        name="email"
        rules={[
          { required: true, message: t`Email Address is required.` },
          { type: 'email', message: t`Invalid email address.` },
        ]}
      >
        <InputField
          label={t`Email Address`}
          inputMode="email"
          role="textbox"
          aria-label="email"
          data-testid="email"
        />
      </Field>
      <Button type="submit" role="button" expand="block" disabled={isLoading}>{t`Continue`}</Button>
    </Form>
  );
};

export default EmailForm;
